import { toast } from 'react-toastify'

const apiError = (error) => {
  console.error('API Error:', error)
  let errorMessage = 'An error occurred. Please try again later.'

  // Handle specific error response structure
  if (error?.data?.errors?.reason) {
    errorMessage = error?.data?.errors?.reason
  }
  // Handle different HTTP status codes
  else if (error?.status === 401) {
    errorMessage = 'Invalid email or password. Please check your credentials and try again.'
  } else if (error?.status === 403) {
    errorMessage = 'Access denied. You do not have permission to perform this action.'
  } else if (error?.status === 404) {
    errorMessage = 'The requested resource was not found.'
  } else if (error?.status === 422) {
    errorMessage = 'Please check your input and try again.'
  } else if (error?.status >= 500) {
    errorMessage = 'Server error. Please try again later.'
  }
  // Handle network errors
  else if (error?.status === 'FETCH_ERROR') {
    errorMessage = 'Network error. Please check your connection and try again.'
  }

  toast.error(errorMessage)
}

export default apiError
